import { useEffect, useState } from 'react'
import { experienciasApi } from '../api/experiencias'
import { colors, radius, space, sx, text } from '../design/tokens'

/**
 * Las tres historias de Instagram de una experiencia (Martin, 30 sep 2026:
 * "dejame las tres historias listas para descargar y subir a Instagram").
 * Las arma el servidor desde los campos del evento con las plantillas A · B ·
 * C; acá solo se muestran y se descargan. El padre la monta con `key` =
 * versión: al guardar se remonta y las pide de nuevo (salen regeneradas).
 */
const VARIANTES = [
  { clave: 'a', nombre: 'Foto a sangre' },
  { clave: 'b', nombre: 'Invitación' },
  { clave: 'c', nombre: 'Editorial' },
]

export default function HistoriasExperiencia({ experienciaId, slug }) {
  const [urls, setUrls] = useState({})
  const [error, setError] = useState('')

  useEffect(() => {
    let vivo = true
    const creadas = []
    VARIANTES.forEach(({ clave }) => {
      experienciasApi.historia(experienciaId, clave)
        .then(({ data }) => {
          const url = URL.createObjectURL(data)
          creadas.push(url)
          if (vivo) setUrls((u) => ({ ...u, [clave]: url }))
        })
        .catch(() => { if (vivo) setError('No se pudieron generar las historias. Probá de nuevo en un rato.') })
    })
    return () => { vivo = false; creadas.forEach((u) => URL.revokeObjectURL(u)) }
  }, [experienciaId])

  return (
    <section style={{ ...sx.card, marginBottom: space.xl }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: space.md, marginBottom: space.lg }}>
        <h3 style={sx.cardTitle}>Historias de Instagram</h3>
        <span style={st.ayuda}>1080 × 1920 · se arman solas con los datos del evento</span>
      </div>
      {error && <p style={{ ...st.ayuda, color: colors.err }}>{error}</p>}
      <div style={st.grilla}>
        {VARIANTES.map(({ clave, nombre }) => (
          <figure key={clave} style={st.figura}>
            <div style={st.marco}>
              {urls[clave]
                ? <img src={urls[clave]} alt={`Historia ${clave.toUpperCase()} · ${nombre}`} style={st.imagen} />
                : <span style={st.ayuda}>Generando…</span>}
            </div>
            <figcaption style={st.pie}>
              <span style={{ fontWeight: 600, color: colors.text }}>{clave.toUpperCase()} · {nombre}</span>
              {urls[clave] && (
                <a href={urls[clave]} download={`historia-${clave}-${slug || experienciaId}.jpg`} style={st.descargar}>
                  ↓ Descargar
                </a>
              )}
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  )
}

const st = {
  ayuda: { fontSize: text.sec, color: colors.textSec },
  grilla: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: space.lg },
  figura: { margin: 0, display: 'flex', flexDirection: 'column', gap: space.sm },
  marco: {
    aspectRatio: '9 / 16', background: colors.bgSoft, border: `1px solid ${colors.border}`,
    borderRadius: radius.sm, overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  imagen: { width: '100%', height: '100%', objectFit: 'cover', display: 'block' },
  pie: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: space.sm, fontSize: text.sec },
  descargar: { color: colors.link, fontWeight: 600, textDecoration: 'none' },
}
